import { createSelector } from 'reselect';
import { RootState } from '../../store';

const stateSelector = (state: RootState) => state.mouse;

export const selectMousePosition = createSelector(
    stateSelector,
    mouse => mouse,
);
